import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { XpoDialogManagerService } from '../services/xpo-dialog-manager.service';

@Injectable()
export class ScopeCheckGuard implements CanActivate {
  constructor(private userService: UserService, private dialogManager: XpoDialogManagerService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.userService.isUserLoggedIn$.pipe(
      map(() => {
        const checkManagerRole: boolean = true;
        const isAuthorized: boolean = this.userService.isCurrentUserAuthorizedToAccess(checkManagerRole);
        if (!isAuthorized) {
          this.userService.logNotAuthorizedUser();
          this.dialogManager.showNotAuthorizedDialog();
        }

        return isAuthorized;
      })
    );
  }
}
